import { Routes } from '@angular/router';
import { Machine } from 'src/app/core/pages/machine/machine';
import { DashboardLayoutComponent } from 'src/app/core/layouts/dashboard-layout/dashboard-layout';
import { machineResolver } from 'src/app/shared/resolvers/machine.resolver';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: DashboardLayoutComponent,
    children: [{
      path: 'machine/:machine-id',
      pathMatch: 'full',
      component: Machine,
      resolve: { machine: machineResolver }
    }]
  }
];
